import React, { Component } from 'react';
import swal from 'sweetalert';

import LabelForm from '../../../components/LabelForm';
import SelectForm from '../../../components/SelectForm';
import Modal from '../../../components/Modal';
import BiometricsData from '../BiometricsData';
import VitalSignsData from '../VitalSignsData';

import { isValidForm } from '../../../libs/functions';
import {biometricsDataSave, incidentsOption, lookupNotRender, lookupsNotRender} from '../../../libs/services';


class BiometricsVitalSigns extends Component{
    constructor(props){
        super(props);

        this.onSave = this.onSave.bind(this);
        this.opemModal = this.openModal.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getIncidents = this.getIncidents.bind(this);

        this.state = {
            section:'',
            name:'',
            number:'',
            date:'',
            incident_id:'',
            incidents:[],            
            invalid_sample:'',
        }

    }

    componentDidMount(){
        this.props.onRef(this);

    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async openModal({name, donation_number, date, sex, section}){
        await this.setState({
            section: section,
            name: name,
            number: donation_number,
            date: date
        });

        await this.modal.handleShow();
        await this.props.waiting.handleShow('Cargando...');

        if(this.state.section === 'vital_signs'){           
            await this.vital_signs.getVitalSigns(sex);

            await this.getIncidents('INCIDENT_SVITALES');
            
        }else{
            await this.biometrics.getBiometrics(sex);

            await this.getIncidents('INCIDENT_BIOMETRICOS');
        }

        await this.props.waiting.handleClose();
    }

    async getIncidents(key){
        var response = await  lookupsNotRender('incident_type');
        if(response){
            var index = response.findIndex(item => item.key === key);
            if(index !== -1){
                response = await incidentsOption(response[index].key);
                var options = response.map((res)=>{
                    var obj = {
                        value: res.id,
                        text: res.name
                    };

                    return obj;
                });

                this.setState({incidents: options});
            }
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async onSave(){
        var id = this.props.match.params.id === undefined ? this.props.variables.id : this.props.match.params.id;
        var error = '';
        if(!isValidForm('div.form-biometrics')){
            error = 'Campos Incompletos';
        }

        var items = [];
        var object = {};
        var options = []
        if(this.state.section === 'vital_signs'){
            options = this.vital_signs.state.vital_signs;
                        
        }else{
            options = this.biometrics.state.biometrics;
        }

        items = [];
        options.forEach((item, i)=>{
            var obj = {                
                biometrics_id: item.id
            }

            if(this.state.section === 'vital_signs'){
                obj.value = i === 0 && item.value.toString().indexOf('.') === -1 ? (parseInt(item.value) / 100) : item.value;
            }else{
                obj.value = item.value;
            }

            //cambiar ruta de edicion para agregar el tipo de registro
            obj.offering_cell_id =  id;

            if(obj.value !== '' && obj.value !== null){
                items.push(obj);
            }
        });

        object = {
            values: items,
            offering_cell_id: id,
            type:this.state.section === 'vital_signs' ? 'BIO_F_SIGNOS' : 'BIO_F_BIO',
            sample_valid:this.state.section === 'vital_signs' ?  this.vital_signs.state.sample_valid :
                            this.state.invalid_sample === "" ? null :
                            this.state.invalid_sample === 'SI' ? true :
                            this.state.invalid_sample === 'NO' ? false : null,
            incident_id: this.state.incident_id
        };

        if(items.length === 0){
            error = '¡No ha agregado ningun valor!';
        }

        if(error === ''){
            var response = await biometricsDataSave(object, this.props.waiting);
            if(response){
                swal(
                    'Correcto', 
                    (this.state.section === 'vital_signs' ? 'Signos Vitales Guardados' : 'Biometría Hemática Guardada'), 
                    'success'
                );
                this.modal.handleClose();
            }
           
        }else{
            swal('Error', error, 'error');
        }
    }

    onClose(){
        this.setState({
            section:'',
            name:'',
            number:'',
            date:'',
            incident_id:'',
            incidents:[],            
            invalid_sample:''
        });
    }

    render(){
        return(
            <Modal
                title={this.state.section === 'vital_signs' ? 'Signos Vitales' : 'Biometría Hemática'}
                actionBtn={true}
                label="Guardar"
                action={this.onSave}                
                clear={this.onClose}
                onRef={ref => this.modal = ref}
            >
                <div className='row'>
                    <div className='col-xs 12'>
                        <div className='col-xs-12'>
                            <label style={{marginRight:8}}>Donador:</label>
                            <LabelForm text={this.state.name} />
                        </div>
                        <div className='col-xs-12 col-sm-6'>
                            <label style={{marginRight:8}}>Ofrecimiento</label>
                            <LabelForm text={this.state.number} />
                        </div>
                        <div className='col-xs-12 col-sm-6'>
                            <label style={{marginRight:8}}>Fecha</label>
                            <LabelForm text={this.state.date} />
                        </div>
                    </div>
                    <div className='col-xs-12 form-biometrics'>
                        {this.state.section === 'biometrics' ?
                            <BiometricsData 
                                {...this.props} 
                                container={"col-xs-12 col-sm-6 col-sm-offset-3"}
                                vertical
                                handleChange={this.handleChange}
                                onRef={ref => this.biometrics = ref} 
                            />
                        :
                            <VitalSignsData 
                                {...this.props} 
                                container={"col-xs-12 col-sm-6 col-sm-offset-3"}
                                vertical
                                handleChange={this.handleChange}
                                onRef={ref => this.vital_signs = ref} 
                            />
                        }
                    </div>

                    {this.state.section === 'biometrics' &&
                        <div className="col-xs-12">
                            <div className='col-xs-12 col-sm-6 col-sm-offset-3'>
                                <LabelForm text="Muestra Válida" />
                                <SelectForm 
                                    id="invalid_sample"
                                    value={this.state.invalid_sample}
                                    options={[{value:'SI', text:'SI'}, {value:'NO', text:'NO'}]}
                                    handleChange={this.handleChange}
                                />
                            </div>
                        </div>
                    }

                    {(this.state.section === 'vital_signs' || this.state.invalid_sample === 'NO') &&
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-6 col-sm-offset-3'>
                                <LabelForm text="Tipo Incidente" />
                                <SelectForm 
                                    id="incident_id"
                                    value={this.state.incident_id}
                                    options={this.state.incidents}
                                    handleChange={this.handleChange}
                                />
                            </div>
                        </div>
                    }
                    
                </div>
                
                
            </Modal>
        )
    }
}

export default BiometricsVitalSigns;